export default class BrandclubStoreConfigUtils {
  public static readonly stripeDebugMode = false;

  public static getAppStage(): 'localhost' | 'beta' | 'gamma' | 'prod' {
    const nodeEnv = import.meta.env?.MODE || process.env.NODE_ENV;

    if (nodeEnv === 'development') {
      return 'localhost';
    }

    const origin = window.location.origin;
    if (origin.includes('beta.brandclub') || origin.includes('-beta.') || origin.includes('beta-')) {
      return 'beta';
    }

    if (origin.includes('gamma.brandclub') || origin.includes('-gamma.') || origin.includes('gamma-')) {
      return 'gamma';
    }

    return 'prod';
  }

  public static getWebAppId() {
    return window.location.hostname;
  }

  private static authDomainCache = new Map<string, string>();
  private static baseDomain = "";

  public static getAuthDomain(appStage: 'localhost' | 'beta' | 'gamma' | 'prod' = 'prod') {
    // Check cache first
    if (this.authDomainCache.has(appStage)) {
      return this.authDomainCache.get(appStage)!;
    }

    // Get the base domain first
    const baseDomain = this.getBaseDomain();

    // Construct stage-specific auth domain
    let authDomain: string;
    if (appStage === 'prod' || !baseDomain.includes('brandclub.com')) {
      // Production uses the base domain directly or if the base domain does not include brandclub.com
      authDomain = baseDomain;
    } else {
      // Other stages use stage.basedomain format
      authDomain = `${appStage}.${baseDomain}`;
    }

    // Cache the result
    this.authDomainCache.set(appStage, authDomain);
    return authDomain;
  }

  public static getBaseDomain(): string {
    if (this.baseDomain) {
      return this.baseDomain;
    }

    const hostname = window.location.hostname.toLowerCase();
    // Split the hostname and get the parts
    const parts = hostname.split('.');

    // If we have less than 2 parts, return the whole hostname
    if (parts.length < 2) {
      this.baseDomain = hostname;
      return hostname;
    }

    // Extract base domain, handling multi-part TLDs
    const tld = parts[parts.length - 1];
    let baseDomain: string;

    if (tld.length === 2 && parts.length >= 3) {
      // Country code TLD, likely has structure like .co.in, .com.au
      baseDomain = parts.slice(-3).join('.');
    } else {
      // Generic TLD (.com, .org, .net, etc.) - take last 2 parts
      baseDomain = parts.slice(-2).join('.');
    }

    this.baseDomain = baseDomain;
    return baseDomain;
  }

  public static getApiHostName(): string {
    return `${window.location.origin}/api-rewards`;
  }

  public static getServerSideSyncHostName(): string {
    return `${window.location.origin}/api-retailer-sync`;
  }

  public static getGoogleMapsApiKey(): string {
    return 'AIzaSyDIvKiFNOD6JC_3ZXMeE4rtPVw49BFanJg';
  }

  public static getGoogleMapsMapId(): string {
    return '6b6881fc70e2cb88'; // Created in google cloud console
  }

  public static getEdgeCachedApiHostName(): string {
    return `${window.location.origin}/api-rewards`;
  }

  public static getGraphQlUri(): string {
    const base = this.getApiHostName();
    return `${base}/graphql`;
  }

  public static getStripePublishableKey(): string {
    const appStage = this.getAppStage();
    if (appStage === 'localhost' && this.stripeDebugMode) {
      return 'pk_test_51LnQyZJrInA7nkEZROUUcHyEsSs2CP3eWlIzOzIk6eMyGIKF8vsjZ4cGFjxrjZas6FlwTs2F9YvxrGsbdwojbxRO00IBijaZzD';
    }

    return 'pk_live_51LnQyZJrInA7nkEZJwYqka6fFt6Zz8m1V3l4hC2Rn3N3iLXCWgd8K3oQonZw3SWdpZoZ1UPogaw3kQwt5DyWnVXz00Mr9PFmjh';
  }

  public static getServerSideSyncGraphQlUri(): string {
    const base = this.getServerSideSyncHostName();

    return `${base}/graphql`;
  }
}
